import { Injector } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { AuthType, ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ReactShellConfigService } from '../shared/shared-context/react-shell-config.service';
import { isAppShell } from './is-app-shell.utility';

// tslint:disable:naming-convention
declare namespace HomePage {
    abstract class ShellUtil {
        public static HydrateCommercialReactShell(navBarData: any, isPwa?: boolean, shellConfig?: any): void;
        public static BootstrapReactShell(workloadId: string, shellConfig?: any, capabilities?: any): boolean;
    }
}

/**
 * Initialize the ReactShell from AppShell mode, since it can't be setup through our regular Page Response flow.
 * This is because the installed HTML doesn't know which user is going to run the app, and therefore we can't decide
 * to run the consumer or commercial bootstrapper.
 * Instead, we run it from the client as soon as our app has bootstrapped.
 */
export function initializeShellClient(
    injector: Injector,
    configParserService: ConfigParserService,
    clientStartupConfigService: ClientStartupConfigService
) {
    if (!isAppShell()) {
        return () => { /* Do nothing */ };
    }

    return () => {
        const reactShellConfigService = injector.get(ReactShellConfigService);
        const reactShellConfig = reactShellConfigService.reactShellConfig;

        const capabilitiesService = injector.get(CapabilitiesService);
        const capabilities = capabilitiesService.capabilities;

        const shellScript = document.createElement('script');
        shellScript.src = reactShellConfig.resourceUrl;
        shellScript.crossOrigin = 'anonymous';
        shellScript.async = true;
        shellScript.type = 'text/javascript';
        shellScript.onload = () => {
            HomePage.ShellUtil.BootstrapReactShell('IWApp', reactShellConfig, capabilities);

            if (clientStartupConfigService.config.authType === AuthType.OrgId) {
                const navBarData = configParserService.parse<any>('navBarData');
                HomePage.ShellUtil.HydrateCommercialReactShell(navBarData, false /* isPwa */, reactShellConfig);
            }
        };
        document.body.appendChild(shellScript);
    };
}
